

<div class="title">
  <div>
    <span class="calendar-name">{{ "myCalendar" | translate }}</span>
    <input
      style="margin-left: 20px; font-family: Noto Sans JP;"
      type="checkbox"
      (change)="onIncludePastChange($event)"
      [(ngModel)]="include_past"
    /> {{ "showPastEvents" | translate }}
  </div>
  <div>
    <button
      class="items-center justify-center text-center button h-10 text-lg cursor-pointer rounded"
      style="width: 200px; margin-right: 15px;"
      (click)="goJoin()"
    >
      {{ "joinRoom" | translate }}
    </button>
    <button
      class="items-center justify-center text-center button h-10 text-lg cursor-pointer rounded"
      style="width: 180px;"
      (click)="addEvent()"
    >
      {{ "addEvent" | translate }}
    </button>
  </div>
</div>
<full-calendar [options]="calendarOptions" class="calendar"></full-calendar>
